export const sliderArticles = [
  {
    headline: 'Use your time and space smarter',
    description:
      'Never again run out of coffee or other supplies. Create an efficient hive for yout busy bees.',
  },
  {
    headline: 'Never stress about me',
    description:
      'Zonifero will measure how you use the rooms so that you always have enough rooms available',
  },
  {
    headline: 'Use your time and space smarter',
    description:
      'Never again run out of coffee or other supplies. Create an efficient hive for yout busy bees.',
  },
  {
    headline: 'Never stress about me',
    description:
      'Zonifero will measure how you use the rooms so that you always have enough rooms available',
  },
  {
    headline: 'Use your time and space smarter',
    description:
      'Never again run out of coffee or other supplies. Create an efficient hive for yout busy bees.',
  },
  {
    headline: 'Use your time and space smarter',
    description:
      'Never again run out of coffee or other supplies. Create an efficient hive for yout busy bees.',
  },
  {
    headline: 'Never stress about me',
    description:
      'Zonifero will measure how you use the rooms so that you always have enough rooms available',
  },
  {
    headline: 'Use your time and space smarter',
    description:
      'Never again run out of coffee or other supplies. Create an efficient hive for yout busy bees.',
  },
  {
    headline: 'Never stress about me',
    description:
      'Zonifero will measure how you use the rooms so that you always have enough rooms available',
  },
  {
    headline: 'Use your time and space smarter',
    description:
      'Never again run out of coffee or other supplies. Create an efficient hive for yout busy bees.',
  },
  {
    headline: 'Use your time and space smarter',
    description:
      'Never again run out of coffee or other supplies. Create an efficient hive for yout busy bees.',
  },
  {
    headline: 'Never stress about me',
    description:
      'Zonifero will measure how you use the rooms so that you always have enough rooms available',
  },
];
